<template>
  <div class="modal-wrap-3" style="display: flex" @click="closeModal">
    <div class="modal-inner" @click.stop>
      <button type="button" class="close-modal" @click="closeModal">
        <img src="@/assets/images/icon/ico_close_w.svg" alt="닫기"/>
      </button>

      <div class="modal-content" v-if="step === 1">
        <h4>회원 탈퇴를 원하시는 이유를 저희에게 말해줄 수 있나요?</h4>
        <div class="withdraw-reason-wrapper">
          <label class="reason-label">
            <input
                type="radio"
                value="yes"
                v-model="reasonOption"
                @change="focusInput"
            />
            <span> 네, </span>
            <input
                type="text"
                v-model="withdrawReason"
                :disabled="reasonOption !== 'yes'"
                placeholder="작성해 주세요"
                maxlength="1000"
                class="reason-input"
                ref="reasonInput"
            />
          </label>
          <label class="reason-label">
            <input type="radio" value="no" v-model="reasonOption"/>
            아니오, 바로 탈퇴하겠습니다.
          </label>
        </div>

        <div class="button-box">
          <button :disabled="!reasonOption" @click="nextStep">확인</button>
        </div>
      </div>

      <div class="modal-content" v-if="step === 2">
        <h4>잠깐, 탈퇴 전 확인하세요!</h4>
        <p>
          회원 탈퇴를 하더라도 ART & ARTISTS 페이지에 노출되는 정보는 그대로 유지됩니다. 이를 원하지 않는다면, hello@article21.co.kr 또는 1:1문의를 통해 아이디 정보와 함께 회원 정보 삭제 요청을 해주세요.
        </p>
        <p>
          mimio 재가입 시 탈퇴 전 아이디는 사용 불가합니다.<br/>
          탈퇴 시 삭제 요청하지 않은 프로필 및 작품 정보의 연동을 원할 경우 1:1 문의를 이용해주세요.
        </p>
        <p>정말 탈퇴하시겠습니까?</p>

        <div class="final-confirm-wrapper">
          <label>
            <input type="radio" value="confirm" v-model="finalConfirm"/>
            네, 탈퇴하겠습니다.
          </label>
          <label>
            <input type="radio" value="cancel" v-model="finalConfirm"/>
            아니오, 회원을 유지하겠습니다.
          </label>
        </div>


        <div class="button-box">
          <button @click="confirmWithdrawal">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineEmits, ref} from "vue";
import {useRouter} from "vue-router";
import {useUiStore} from "@/store/useUiStore";
import {apiClient} from "@/services/auth-header";
import {useAuthStore} from "@/store/auth.module";
import {USER_ROLE} from "@/common/common-enum";

const emit = defineEmits(['close']);

const step = ref(1);
const reasonOption = ref(null); // 'yes' or 'no'
const withdrawReason = ref("");
const finalConfirm = ref(null);
const reasonInput = ref(null);

const uiStore = useUiStore();
const router = useRouter();

const authStore = useAuthStore();
const user = authStore.status.user;
const isArtist = ref(user.roleType === USER_ROLE.ARTIST);

const closeModal = () => {
  emit('close');
};

const focusInput = () => {
  // 라디오가 yes로 선택되면 input에 포커스
  if (reasonOption.value === "yes" && reasonInput.value) {
    reasonInput.value.focus();
  }
};

const nextStep = () => {
  if (reasonOption.value === "yes" && withdrawReason.value.trim() === "") {
    alert("탈퇴 이유를 작성해 주세요.");
    return;
  }

  if (isArtist.value) {
    step.value = 2;
  } else {
    confirmWithdrawal();
  }
};

const confirmWithdrawal = async () => {

  if (finalConfirm.value == 'cancel') {
    closeModal();
    return;
  }

  try {
    uiStore.showLoading();
    const response = await apiClient.put("/v1/users/withdraw", {
      withdrawReason: reasonOption.value === "yes" ? withdrawReason.value : "",
    });

    closeModal();
    router.push({name:'Home'}).then(value => {
      authStore.logout();
      alert("회원 탈퇴가 완료되었습니다.");
      location.reload();
    });

  } catch (e) {
    //
  } finally {
    uiStore.hideLoading();
  }
};
</script>

<style scoped>
.reason-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reason-input {
  flex-grow: 1;
  min-width: 0;
}

.modal-wrap-3 {
  /* 기존 스타일 유지 */
}

.modal-inner {
  /* 기존 스타일 유지 */
}

.button-box {
  margin-top: 16px;
}

.reason-input {
  flex-grow: 1;
  min-width: 0;
  text-align: left; /* 추가 */
}

.modal-content {
  text-align: left; /* 전체 텍스트 좌측 정렬 */
}

.modal-wrap-3 .modal-inner .modal-content {
  padding: 60px 30px;

  /* 중앙 정렬 제거
  align-items: flex-start;
  text-align: left;

   */
}

.modal-inner label {
  display: block;
  margin-bottom: 8px;
}

.modal-wrap-3 .modal-inner .modal-content h4,
.modal-wrap-3 .modal-inner .modal-content p {
  word-break: keep-all;

}

.modal-wrap-3 .modal-inner .modal-content p{
  text-align: left;
}

.withdraw-reason-wrapper {
  text-align: left;
}

.withdraw-reason-wrapper .reason-label {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  text-align: left;
}

.final-confirm-wrapper {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

</style>
